import $ from "jquery/dist/jquery";

$(() => {
  function updateCartContent(data) {
    $("#cartContent").html(data.newCart);
    $("#cart").trigger("eshop:add", [data, false]);
    if (data.gtmJSONs_added?.length > 0) {
      $("#cart").trigger("eshop:item-add", [data.gtmJSONs_added]);
    }
    if (data.gtmJSONs_removed?.length > 0) {
      $("#cart").trigger("eshop:item-remove", [data.gtmJSONs_removed]);
    }

    if (!data.voucherOk) {
      $(".voucherCode")
        .addClass("error")
        .attr("placeholder", "Slevový kód není platný!");
      $(".voucherCode")
        .parents(".collapse")
        .each(function () {
          window.NXCMS.collapse(this, true);
        });
    }
    window.NXCMS.showMessages(data.messages);
  }

  let updateCartAjax = null;

  function updateCart(e, onSuccess) {
    let formtop = $(e.target).closest("#cartContent, .cartContentTop");
    if (updateCartAjax) {
      updateCartAjax.abort();
      updateCartAjax = null;
    }

    let cartData = formtop
      .find("input.count, input.voucherCode, input.ecoPackaging")
      .serialize();
    updateCartAjax = $.ajax({
      url: window.NXURLS.URL_ESHOP_MODIFY_CART,
      method: "POST",
      data: cartData,
    })
      .done((data) => {
        if (onSuccess) {
          onSuccess(data);
        }
      })
      .fail((data) => {
        if (data.statusText !== "abort") {
          window.NXCMS.toast("Nepovedlo se změnit obsah košíku!", 4000);
        }
      })
      .always(() => {
        updateCartAjax = null;
      });
  }

  $("#cartContent").on("change", "input.count", (e) =>
    updateCart(e, updateCartContent)
  );
  $("#cartContent").on("change", "input.ecoPackaging", (e) =>
    updateCart(e, updateCartContent)
  );

  function fixInputValue(ci, nv) {
    const min_val = ci.attr("data-min-val") || 0;
    const max_val = ci.attr("data-max-val") || 9999;
    const warn_val = ci.attr("data-warn-val") || 99999999;
    const warn2_val = ci.attr("data-warn2-val") || 99999999;

    if (nv == null) {
      nv = parseInt(ci.val());
    }
    if (nv < min_val) {
      nv = min_val;
    }
    if (nv > max_val) {
      nv = max_val;
      $(document).trigger("eshop:qty-capped");
    }

    if (ci.attr("data-warn-target")) {
      if (nv > warn2_val) {
        $(ci.attr("data-warn-target")).find(".stock-no-warn").hide();
        $(ci.attr("data-warn-target")).find(".stock-warn").hide();
        $(ci.attr("data-warn-target")).find(".stock-warn2").show();
      } else if (nv > warn_val) {
        $(ci.attr("data-warn-target")).find(".stock-no-warn").hide();
        $(ci.attr("data-warn-target")).find(".stock-warn").show();
        $(ci.attr("data-warn-target")).find(".stock-warn2").hide();
      } else {
        $(ci.attr("data-warn-target")).find(".stock-no-warn").show();
        $(ci.attr("data-warn-target")).find(".stock-warn").hide();
        $(ci.attr("data-warn-target")).find(".stock-warn2").hide();
      }
    }

    return nv;
  }

  $(".quantityInput, input.count").on("change", (e) => {
    const b = $(e.target);
    b.val(fixInputValue(b, null));
  });

  $("#cartContent, .quantityCounter").on("click", ".inc", (e) => {
    const b = $(e.target);
    let ci = null;

    if (b.attr("data-target")) {
      ci = $(b.attr("data-target"));
    } else {
      ci = $("#cart_item_" + b.attr("rel"));
    }
    let nv = parseInt(ci.val());
    const step_val = parseInt(ci.attr("data-step-val")) || 1;
    if (nv < 0) {
      nv = 0;
    }
    nv += step_val;
    ci.val(fixInputValue(ci, nv));
    ci.change();
  });

  $("#cartContent, .quantityCounter").on("click", ".dec", (e) => {
    const b = $(e.target);
    let ci = null;

    if (b.attr("data-target")) {
      ci = $(b.attr("data-target"));
    } else {
      ci = $("#cart_item_" + b.attr("rel"));
    }
    let nv = parseInt(ci.val());
    const step_val = parseInt(ci.attr("data-step-val")) || 1;
    nv -= step_val;
    ci.val(fixInputValue(ci, nv));
    ci.change();
  });

  $("#cartContent").on("click", ".removeItem", (e) => {
    e.preventDefault();
    $(e.target).closest("tr, .cartItemBoxTab").find("input.count").val("0");
    updateCart(e, updateCartContent);
    return false;
  });

  $("#cartContent").on("click", ".voucherCheck", (e) => {
    e.preventDefault();
    updateCart(e, updateCartContent);
    return false;
  });

  $("#cartContent").on("click", ".voucherRemove", function (e) {
    e.preventDefault();
    const code = $(this).data("voucher-code");

    $.ajax({
      url: window.NXURLS.URL_ESHOP_MODIFY_CART_REMOVE_VOUCHER,
      method: "POST",
      data: {
        code: code,
      },
    })
      .done((data) => {
        updateCartContent(data);
      })
      .fail((data) => {
        if (data.statusText !== "abort") {
          window.NXCMS.toast("Nepovedlo se změnit obsah košíku!", 4000);
        }
      });

    return false;
  });

  $("#cartContent").on("click", ".btn-to-delivery", (e) => {
    e.preventDefault();
    const toUrl = $(e.target).attr("href");
    updateCart(e, () => {
      window.location = toUrl;
    });
    return false;
  });
});
